import { css } from 'styled-components';

const generateMediaCSS = breakPoint => {
    return styles => {
        return css`
            @media screen and (max-width: ${breakPoint}px) {
                ${styles}
            }
        `;
    };
};

export const mobileMQ = generateMediaCSS(760);
export const tableMQ = generateMediaCSS(920);
export const desktopMQ = generateMediaCSS(1024);
export const bigDesktopMQ = generateMediaCSS(1366);
